import Player from '@vimeo/player/dist/player.es'
import {SimplePopup} from "./simplePopup";
import {WebinarWatcher} from "../../../../../vet-webinar-watcher/Resources/Private/JavaScript/webinar-watcher";

export class VimeoVideo {
    constructor() {
        let _this = this;

        $('[data-popup-video]').fancybox({
            afterShow: function () {
                if (typeof _paq !== 'undefined') {
                    _paq.push(['MediaAnalytics::scanForMedia']);
                }
            },
        })

        jQuery('.webinarList [data-vimeo-video]').on('click', function () {
            let webinarUid = parseInt($(this).data('webinar'));
            let webinarWatchedTime = parseInt($(this).data('webinar-watched-time'));
            let webinarEnded = $(this).data('webinar-ended') === '1';
            let webinarType = 'agenda';

            if (_this.isRatingEnabled(webinarUid) && !_this.isWebinarRated(webinarUid)) {
                _this.showPopup(webinarUid)
            }

            if (webinarEnded) {
                return;
            }

            let acceptablePercentage = parseFloat($(this).data('acceptable-percentage')) / 100;
            if (acceptablePercentage <= 0 || isNaN(acceptablePercentage)) {
                acceptablePercentage = 0.8;
            }
            let instance = $.fancybox.getInstance().$refs.inner[0];
            let iframe = instance.querySelector('iframe');

            new WebinarWatcher(iframe, webinarUid, webinarWatchedTime, webinarEnded, webinarType);

            _this.player = new Player(iframe);
            _this.amountWatched = 0.0;
            _this.previousTime = 0.0;
            _this.enabled = false;

            _this.player.on('timeupdate', (data) => {
                let diff = Math.abs(_this.previousTime - data.seconds);
                if (diff < 0.5) {
                    _this.amountWatched += diff;
                }
                _this.previousTime = data.seconds;

                if (data.percent >= acceptablePercentage) {
                    $(this).data('webinar-watched-time', _this.amountWatched)
                    if (_this.enabled === false) {
                        this.enabled = true;
                        _this.enableRating(webinarUid)
                        _this.showPopup(webinarUid)
                        _this.enableQuiz(webinarUid)
                    }
                }
            });
            _this.player.on('ended', (data) => {
                $(this).data('webinar-ended', '1');
            });
        });
    }

    isWebinarRated(webinarUid) {
        let element = document.querySelector('[data-rating][data-webinar="' + webinarUid + '"]');
        if (element) {
            return element.closest('.c-ratings__wrapper')
                .querySelector('.c-ratings__own .fa-star') !== null
        }
        return false;
    }

    isRatingEnabled(webinarUid) {
        let element = document.querySelector('[data-rating][data-webinar="' + webinarUid + '"]');
        if (element) {
            return !element.closest('.c-ratings__wrapper')
                .querySelector('.c-ratings__right').classList.contains('invisible')
        }
        return false;
    }

    enableRating(webinarUid) {
        let element = document.querySelector('[data-rating][data-webinar="' + webinarUid + '"]');
        if (element) {
            element.closest('.c-ratings__wrapper')
                .querySelector('.c-ratings__right')
                .classList.remove('invisible');
        }
    }

    enableQuiz(webinarUid) {
        let quizLink = document
            .querySelector('[data-vimeo-video][data-webinar="' + webinarUid + '"]')
            .parentElement
            .querySelector('.c-agenda__quiz-btn');
        if (quizLink !== null) {
            quizLink.classList.add('c-agenda__quiz-btn--show');
        }
    }

    showPopup(webinarUid) {
        let element = jQuery('[data-rating][data-webinar="' + webinarUid + '"]');
        if (element) {
            let ratingsWrapper = element
                .parents('.c-ratings__wrapper')
                .find('.c-ratings__right');

            let popup = new SimplePopup(ratingsWrapper, {content: 'Did you enjoy the webinar?'})
            popup.show();
        }
    }
}
